export function taxFilter() {
  return {
    activeTax: 'all',

    // 자동 생성 결과
    taxList: ['all'],
    counts: {},

    // 섹션에 넣은 라벨 JSON
    labels: { all: '전체' },

    // 보기 방식: 'list' | 'thumb' (data-view-storage-key가 있을 때만 사용)
    view: 'thumb',
    viewStorageKey: '',

    init() {
      // 0) 보기 방식 복원
      this.viewStorageKey =
        this.$root.getAttribute('data-view-storage-key') || '';
      if (this.viewStorageKey) {
        try {
          const saved = localStorage.getItem(this.viewStorageKey);
          if (saved === 'list' || saved === 'thumb') this.view = saved;
        } catch {
          // storage 접근 불가 시 기본값 유지
        }
      }

      // 1) 라벨 로드 (section의 data-tax-labels)
      this.labels = this.readLabels();

      // 2) DOM에서 data-tax 수집
      const nodes = Array.from(
        this.$root.querySelectorAll('article[data-tax]')
      );
      const set = new Set();
      const counts = {};

      nodes.forEach((el) => {
        const raw = (el.dataset.tax || '').trim();
        if (!raw) return;

        raw.split(/\s+/).forEach((slug) => {
          if (!slug) return;
          set.add(slug);
          counts[slug] = (counts[slug] || 0) + 1;
        });
      });

      // 3) 목록 구성 (all + 실제 사용 중인 taxonomy만)
      const list = Array.from(set);

      // data-tax-sort="dom"이면 목록 등장 순서를 그대로 유지 (product 섹션)
      if (this.$root.getAttribute('data-tax-sort') !== 'dom') {
        // (선택) 우선순위 정렬: care > perm > color, 나머지는 이름/slug 순
        const priority = ['care', 'perm', 'color'];
        list.sort((a, b) => {
          const ai = priority.indexOf(a);
          const bi = priority.indexOf(b);
          if (ai !== -1 || bi !== -1)
            return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
          return a.localeCompare(b);
        });
      }

      this.taxList = ['all', ...list];

      // 4) 카운트 (all 포함)
      this.counts = { ...counts, all: nodes.length };
    },

    readLabels() {
      try {
        const raw = this.$root.getAttribute('data-tax-labels') || '';
        const parsed = raw ? JSON.parse(raw) : {};
        return { all: '전체', ...parsed };
      } catch {
        return { all: '전체' };
      }
    },

    labelOf(slug) {
      return this.labels?.[slug] || slug;
    },

    setTax(slug, event = null) {
      this.disableAos();
      this.activeTax = slug || 'all';
      this.scrollActiveButtonIntoView(event?.currentTarget);
    },

    setView(view) {
      if (view !== 'list' && view !== 'thumb') return;
      if (this.view === view) return;

      this.disableAos();
      this.view = view;

      if (this.viewStorageKey) {
        try {
          localStorage.setItem(this.viewStorageKey, view);
        } catch {
          // storage 접근 불가 시 저장 생략
        }
      }
    },

    scrollActiveButtonIntoView(button) {
      if (!button) return;

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          button.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center',
          });
        });
      });
    },

    disableAos() {
      const nodes = Array.from(
        this.$root.querySelectorAll('article[data-tax][data-aos]')
      );

      nodes.forEach((el) => {
        el.removeAttribute('data-aos');
        el.classList.remove('aos-init', 'aos-animate');
      });

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          window.AOS?.refresh?.();
        });
      });
    },

    match(el) {
      if (this.activeTax === 'all') return true;

      const raw = (el?.dataset?.tax || '').trim();
      if (!raw) return false;

      return raw.split(/\s+/).includes(this.activeTax);
    },
  };
}
